module.exports = __webpack_public_path__ + "video/2500-2_YR_2022_FlashDriveAttacks.e35f63be.vtt";